// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"93f94622","839":"9d369db2"}[chunkId] + ".chunk.css";
};